import { render, staticRenderFns } from "./GlobalPeriodRange.vue?vue&type=template&id=54f41497&"
import script from "./GlobalPeriodRange.vue?vue&type=script&lang=js&"
export * from "./GlobalPeriodRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports